export default {
  init() {
    $('.woocommerce-form-login-toggle .woocommerce-info')
      .find('.showlogin')
        .remove()
        .end()
      .append(`<a class="btn btn--primary" href="${window.app.urls.myAccount}">${window.app.i18n.clickToLogin}</a>`)
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerce_checkout.js